export const GET_AUTO_ASSIGN_SUMMARY_REQUEST = 'GET_AUTO_ASSIGN_SUMMARY_REQUEST';
export const GET_AUTO_ASSIGN_SUMMARY_SUCCESS = 'GET_AUTO_ASSIGN_SUMMARY_SUCCESS';
export const GET_AUTO_ASSIGN_SUMMARY_FAILURE = 'GET_AUTO_ASSIGN_SUMMARY_FAILURE';
